import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'core-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AccessDeniedComponent implements OnInit {

  public errorSize: string = 'large';

  ngOnInit() {
    this.onResize();
  }

  onResize() {
    if (window.innerWidth < 1100) {
      this.errorSize = 'small';
    }
    else if (window.innerWidth < 1450) {
      this.errorSize = 'medium';
    } else {
      this.errorSize = 'large';
    }
  };

}
